var tknRecap = "";
 var lubsCookie ; 
$(document).ready(function() {
    //reset field Email
     $('input[name="txt_email"]').val("");
  
  
    //Seta o primeiro Recapcha; 
    if ($('#recaptchaResponse').length > 0) {
        grecaptcha.ready(function() {
            grecaptcha.execute('6LdJC3IaAAAAAAYX8ClcPEziCnv5HHRdILKyvGqO', {
                action: 'lubsQuiz'
            }).then(function(token) {
                var recaptchaResponse = document.getElementById('recaptchaResponse');
                recaptchaResponse.value = token;
               tknRecap = token
            });
        });
    }
  
    let maxEtapas = $(".todoEtapa").length;
    let formData = {};


    // Pegar o Cookie
    lubsCookie = getCookie("cookie_lubs_id");

    if(!lubsCookie){
         var newLubsId = generateUUID();
         setCookie("cookie_lubs_id", newLubsId, 365);
         lubsCookie = getCookie("cookie_lubs_id");
    }

    function updateBodyClass(etapaId) {
        $("body").removeClass(function(index, className) {
            return (className.match(/(^|\s)etapa-\S+/g) || []).join(' ');
        });
        $("body").addClass("etapa-" + etapaId);
    }

    $(document).on("click", ".controlBtn", function (e) {
        e.preventDefault();

        
        let idEtapaVez = $(".etapaAtiva").attr("id").replace("et_", "");
        let idEtapaVezCont = parseInt(idEtapaVez);

        if (idEtapaVezCont > 1 && !validateCurrentStep()) {
            $(".mensagemErro").html("Por favor, selecione ao menos uma opção antes de continuar.").addClass('erroAtiva').show();
            return;
        }

        if (idEtapaVezCont === maxEtapas && !validateEmailStep()) {
            $(".mensagemErro").html("Por favor, insira um email válido.").addClass('erroAtiva').show();
            return;
        }

        $(".mensagemErro").hide().removeClass('erroAtiva');
        saveStepData();

        if (idEtapaVezCont == maxEtapas) {
          
            //Monta a Request para Meu local mesmo. 
            if ($('#recaptchaResponse').length > 0) {
                  grecaptcha.ready(function() {
                      grecaptcha.execute('6LdJC3IaAAAAAAYX8ClcPEziCnv5HHRdILKyvGqO', {
                          action: 'lubsQuiz'
                      }).then(function(token) {
                          var recaptchaResponse = document.getElementById('recaptchaResponse');
                          recaptchaResponse.value = token;


                             loadStepData("","conslusao-de-quiz");
                        // Exeuta a action de gravar
                        gravaFormQuiz();                        
                      });
                  }).catch(function(error) {
                      // Lidar com o erro
                      alert("Erro ao gerar o reCAPTCHA. Tente novamente.");
                  });
              }

           //animateComponent("#et_" + nextEtapa + " .component-pergunta");

        } else {
            let nextEtapa = idEtapaVezCont + 1;
            $(".etapaAtiva").addClass("etapaOculta").removeClass("etapaAtiva");
            $("#et_" + nextEtapa).removeClass("etapaOculta").addClass("etapaAtiva");
        
            loadStepData(nextEtapa,"avanco-de-etapa"); // Carrega os dados armazenados ao avançar para a próxima etapa
            updateBodyClass(nextEtapa);
            animateComponent("#et_" + nextEtapa + " .component-pergunta");
            montaNavigation(nextEtapa);
        }
    });

    $(document).on("click", ".backEtapa", function (e) {

        if(!$(this).hasClass("backQuiz")){
      
        e.preventDefault();
        saveStepData();

        let idEtapaVez = $(".etapaAtiva").attr("id").replace("et_", "");
        let idEtapaVezCont = parseInt(idEtapaVez);
        let prevEtapa = idEtapaVezCont - 1;

        $(".etapaAtiva").addClass("etapaOculta").removeClass("etapaAtiva");
        $("#et_" + prevEtapa).removeClass("etapaOculta").addClass("etapaAtiva");

        loadStepData(prevEtapa,"recuo-de-etapa");
        animateComponent("#et_" + prevEtapa + " .component-pergunta");
        montaNavigation(prevEtapa);
        }
    });


  

  
  //Função de Gerar UUID
  function generateUUID() {
       // Função para gerar UUID v4
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });

        // Pega os milissegundos desde 1970 para garantir unicidade
        var timestamp = new Date().getTime();

        // Concatena UUID com timestamp para garantir unicidade global
        return uuid + '-' + timestamp;
   }

  // Pega o cookie pelo nome 
  function getCookie(name) {
            var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            if (match) return match[2];
            return null;
   }

  //Seta o cookie com wxpiração de 12 meses
   function setCookie(name, value, days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  
  
//Validar Etapa
    function validateCurrentStep() {
        let isValid = true;
        $('.etapaAtiva .grupoInput').removeClass('erro');
        let inputs = $('input[type="radio"], input[type="checkbox"]', $(".etapaAtiva"));
        if (inputs.length > 0) {
            let checkedInputs = inputs.filter(':checked');
            if (checkedInputs.length === 0) {
                isValid = false;
                inputs.closest('.grupoInput').addClass('erro');
            }
        }
        return isValid;
    }

   // Função para validar o campo de email
function validateEmailStep() {
    let email = $('input[name="txt_email"]').val();
    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let grupoInput = $('input[name="txt_email"]').closest('.grupoInput');

    if (email && emailRegex.test(email)) {
        formData['email'] = [email]; // Armazena o email na variável global formData
        grupoInput.removeClass('erro'); // Remove a classe de erro se o email for válido
        return true;
    } else {
        grupoInput.addClass('erro'); // Adiciona a classe de erro se o email for inválido
        return false;
    }
}

    function saveStepData() {
      /*
        let currentStep = $(".etapaAtiva").attr("id").replace("et_", "");
        formData[currentStep] = [];
        $('input[type="radio"]:checked, input[type="checkbox"]:checked').each(function () {
            formData[currentStep].push($(this).val());
        });
        */
    }

    function loadStepData(step,type) {
      //seta os campos no datalake 

     $pergunta1 = $('input[name="pergunta_1[]"]:checked').val() || "";
      
     $pergunta2 = $('input[name="pergunta_2[]"]:checked').map(function() {
        return this.value;
      }).get().join(', ');

      $pergunta2 = $pergunta2|| "";

      $pergunta3 = $('input[name="pergunta_3[]"]:checked').map(function() {
        return this.value;
      }).get().join(', ');

      $pergunta3 = $pergunta3 || "";
      
      $pergunta4 = $('input[name="pergunta_4[]"]:checked').val() || "";
      
      $pergunta5 = $('input[name="pergunta_5[]"]:checked').val() || "";
      $pergunta6 = $('input[name="pergunta_6[]"]:checked').val() || "";
      $pergunta7 = $('input[name="pergunta_7[]"]:checked').val() || "";
      $pergunta8 = $('input[name="pergunta_8[]"]:checked').val() || "";
      $action_type = type; 
      $email = $('input[name="txt_email"').val() || "";


      Vurl = "https://iodo.digital/bigquery/bq-lubs-eventos";
      
      $.ajax({
            type: "POST",
            url: Vurl, // URL da requisição
            dataType: "json",
            data: {
                txtEmail: $email,
                cookieID: lubsCookie,  
                pergunta_1: $pergunta1,
                pergunta_2: $pergunta2,
                pergunta_3: $pergunta3,
                pergunta_4: $pergunta4,
                pergunta_5: $pergunta5,
                pergunta_6: $pergunta6,
                pergunta_7: $pergunta7,
                pergunta_8: $pergunta8,
                action_type : $action_type
            },
            xhrFields: {
                withCredentials: true // Permite o envio de cookies/credenciais
            },
            success: function(data)
            {
              console.log("evento set"); 
            },
            beforeSend: function() { 
              
            },
            error:function(){ 
                console.log("evento error"); 
            }
      });   
      
   }

    function montaNavigation(etapa) {
        let htmlNavigation = "";
        for (let i = 1; i <= maxEtapas; i++) {
            let classe = etapa === i ? "ativo" : "";
            htmlNavigation += `<span class="itemnav ${classe}"></span>`;
        }
        $(".navVez").html(htmlNavigation);
    }

    function animateComponent(selector) {
        const container = document.querySelector(selector);
        if (!container) {
            console.error("Elemento não encontrado para o seletor:", selector);
            return;
        }

        const textElement = container.querySelector(".title");
        const mgMaiorElement = container.querySelector(".mgMaior");
        const mensagemErroElement = container.querySelector(".mensagemErro");

        if (textElement) {
            const text = textElement.textContent;
            const words = text.split(" ");
            textElement.textContent = "";
            words.forEach((word, index) => {
                const span = document.createElement("span");
                span.textContent = word + " ";
                textElement.appendChild(span);
                gsap.from(span, {
                    opacity: 0,
                    y: 10,
                    ease: "power1.out",
                    duration: 0.6,
                    delay: index * 0.15
                });
            });

            gsap.from(container, {
                opacity: 0,
                y: 20,
                ease: "power1.out",
                duration: 1.5,
                delay: 0.5
            });
        }

        if (mgMaiorElement) {
            gsap.from(mgMaiorElement, {
                opacity: 0,
                y: 10,
                ease: "power1.out",
                duration: 0.6,
                delay: 0.2
            });
        }

        if (mensagemErroElement) {
            gsap.from(mensagemErroElement, {
                opacity: 0,
                y: 10,
                ease: "power1.out",
                duration: 0.6,
                delay: 0.4
            });
        }
    }

    $('input[type="radio"], input[type="checkbox"]').prop('checked', false);

    $('input[type="radio"], input[type="checkbox"]').on('change', function() {
        $(this).closest('.grupoInput').removeClass('erro');
        if ($('input[type="radio"]:checked, input[type="checkbox"]:checked').length > 0) {
            $(".mensagemErro").hide().removeClass('erroAtiva');
        }
    });

    $('input[type="radio"], input[type="checkbox"]').on('change', function() {
        if ($(this).attr('type') === 'radio') {
            $('input[name="' + $(this).attr('name') + '"]').attr('data-value', '');
            $(this).attr('data-value', $(this).val());
        } else if ($(this).attr('type') === 'checkbox') {
            if ($(this).is(':checked')) {
                $(this).attr('data-value', $(this).val());
                $(this).parent().removeClass("erro");
            } else {
                $(this).attr('data-value', '');
                $(this).parent().removeClass("erro");
            }
        }
    });

    $('input[type="radio"], input[type="checkbox"]').on('click', function() {
        if ($(this).attr('type') === 'radio') {
            $('input[type="radio"]').parent().removeClass("ativo").removeClass("erro");
            $(this).parent().addClass("ativo");
        } else if ($(this).attr('type') === 'checkbox') {
            if ($(this).is(':checked')) {
                $(this).parent().addClass("ativo");
                $('.grupoInput').removeClass("erro");
            } else {
                $(this).parent().removeClass("ativo");
                $('.grupoInput').removeClass("erro");
            }
        }
    });

    if(window.innerWidth < 1180) {
        if(!$('.mobCarroussel').hasClass('slick-initialized')){
            mobileOnlySlider();
        }
    }else{
        if($('.mobCarroussel').hasClass('slick-initialized')){
            $('.mobCarroussel').slick('unslick');
        }
    }

    $('#btn-faq-topo-quiz').on('click', function(event) { 
      event.preventDefault();
        $('.todoPopUp').addClass("ativo");
        $('body').addClass("ativo");
    });

    $('#btn-voltar-quiz').on('click', function(event) { 
      event.preventDefault();
        $('.todoPopUp').removeClass("ativo");
        $('body').removeClass("ativo");
    });

       // Registra o plugin ScrollTrigger do GSAP
    gsap.registerPlugin(ScrollTrigger);

    // Função de animação para os elementos
    function animateOnScroll(elementClass) {
        gsap.utils.toArray(elementClass).forEach(function(element) {
            gsap.from(element, {
                opacity: 0,  // Começa com opacidade 0
                y: 50,       // E deslocamento de 50px na direção Y (para baixo)
                duration: 1, // Duração de 1 segundo para a animação
                ease: "power1.out",
                scrollTrigger: {
                    trigger: element,    // A animação será ativada quando o elemento estiver visível
                    start: "top 80%",    // Inicia quando o topo do elemento está a 80% da janela de visualização
                    toggleActions: "play none none none" // Apenas executa uma vez
                }
            });
        });
    }

    // Aplicar animação para .todoProduto
    animateOnScroll('.todoProduto');

    // Aplicar animação para .todoDesconto
    animateOnScroll('.todoDesconto');
});

$( window ).resize(function() {
    if(window.innerWidth < 1180) {
        if(!$('.todoPost').hasClass('slick-initialized')){
            mobileOnlySlider();
        }
    }else{
        if($('.todoPost').hasClass('slick-initialized')){
            $('.todoPost').slick('unslick');
        }
    }
});

function mobileOnlySlider() {
    $('.todoPost').slick({
        variableWidth: true,
        arrows: false,
        adaptiveHeight: false,
        autoplay: false,
        //swipeToSlide: true,
        touchThreshold: 10000000,
        infinite:false,
    });
}


function gravaFormQuiz (){
      $pergunta1 = $('input[name="pergunta_1[]"]:checked').val();
  
      $pergunta2 = $('input[name="pergunta_2[]"]:checked').map(function() {
        return this.value;
      }).get().join(', ');
  
        $pergunta3 = $('input[name="pergunta_3[]"]:checked').map(function() {
        return this.value;
      }).get().join(', ');
  
      $pergunta4 = $('input[name="pergunta_4[]"]:checked').val();
      $pergunta5 = $('input[name="pergunta_5[]"]:checked').val();
      $pergunta6 = $('input[name="pergunta_6[]"]:checked').val();
      $pergunta7 = $('input[name="pergunta_7[]"]:checked').val();
      $pergunta8 = $('input[name="pergunta_8[]"]:checked').val();
      $email = $('input[name="txt_email"').val();
      $recapcha = $('#recaptchaResponse').val();
  
      Vurl = "https://iodo.digital/shopify/grava-cadastro-lp-lubs"; 
  
       $.ajax({
            type: "POST",
            url: Vurl, // URL da requisição
            dataType: "json",
            data: {
                txtEmail: $email,
                cookieID: lubsCookie,  
                respRecapcha: $recapcha,
                pergunta_1: $pergunta1,
                pergunta_2: $pergunta2,
                pergunta_3: $pergunta3,
                pergunta_4: $pergunta4,
                pergunta_5: $pergunta5,
                pergunta_6: $pergunta6,
                pergunta_7: $pergunta7,
                pergunta_8: $pergunta8,
            },
            xhrFields: {
                withCredentials: true // Permite o envio de cookies/credenciais
            },
            success: function(data)
            {
              $("#et_10").removeClass("loadindAjax")
              if(data){
                   $("#et_10").find(".mensagemErro").html("");
                   $("#et_10").find(".mensagemErro").removeClass("erroAtiva");
                   $("#et_10").find(".mensagemErro").fadeOut();

                    $produtos_result = data.result_type;
                    url_redirect = "https://lubs.com.br/pages/quiz-resultados?result=" + $produtos_result;
                    window.location.href = url_redirect;
                
                  //redireciona o resultado;
          
              }else{
                $("#et_10").find(".mensagemErro").html("Erro ao submeter seu quiz. tente novamente mais tarde");
                $("#et_10").find(".mensagemErro").addClass("erroAtiva");
                $("#et_10").find(".mensagemErro").fadeIn();
              }
               
            },
            beforeSend: function() { 
               $("#et_10").addClass("loadindAjax")
            },
            error:function(){ 
                 $("#et_10").removeClass("loadindAjax");
                  $("#et_10").find(".mensagemErro").html("Erro ao submeter seu quiz. tente novamente mais tarde");
                  $("#et_10").find(".mensagemErro").addClass("erroAtiva");
                  $("#et_10").find(".mensagemErro").fadeIn();
            }
      });   
  }

//Btn Cupom
$(document).on("click","#btnCumpom",function(e){
  e.preventDefault();
   var cupomText = $('#text-cupom').text();

    var tempInput = $('<textarea>');
      $('body').append(tempInput);
      tempInput.val(cupomText).select();

      // Copia o texto
      document.execCommand("copy");

      // Remove o elemento temporário
      tempInput.remove();

      alert("Cupom copiado: " + cupomText);
});




